import type { DateCalculation } from 'components/shared/DatePicker/utils';
import { asIsoDate } from 'components/shared/DatePicker/utils';
import { addDays, isValid, parseISO } from 'date-fns';
import { useMemo } from 'react';
import { now } from 'utils/core/now';
import type { TranslatableContent } from 'utils/intl';

const PRESET_DAY_OFFSETS = [1, 2, 3, 4, 5] as const;

export const useTradeAllocationValueDatePresets = (tradeDate: Nullable<string>) => {
  const valueDatePresets = useMemo<DateCalculation[]>(() => {
    const baseDate = getBaseTradeDate(tradeDate);
    return PRESET_DAY_OFFSETS.map(daysToAdd => () => addDays(baseDate, daysToAdd));
  }, [tradeDate]);

  const valueDatePresetTranslations = useMemo<TranslatableContent[]>(
    () => PRESET_DAY_OFFSETS.map(count => ({ id: 'date.presets.tradeDay', values: { count } })),
    [],
  );

  const defaultValueDate = useMemo<string | null>(() => {
    const baseDate = getBaseTradeDate(tradeDate);
    return asIsoDate(addDays(baseDate, 1));
  }, [tradeDate]);

  return {
    valueDatePresets,
    valueDatePresetTranslations,
    defaultValueDate,
  };
};

function getBaseTradeDate(value: Nullable<string>): Date {
  if (!value) {
    return now();
  }

  const parsedDate = parseISO(value);
  return isValid(parsedDate) ? parsedDate : now();
}
